import MarkerIconService from "../../services/map/MarkerIconService";
import RouteService from "../../services/routes/RouteService";

export enum EOperationType {
    InstallationEquipment,
    UninstallationEquipment,
    InstallationElement,
    UninstallationElement,
    ReplacementElement,
    Geolocate
}

export const operationsWithIconUrls: IOperationsWithIconUrl[] = [
    {
        translateKeyName : "operations.equipment-installation",
        iconPath: MarkerIconService.OPERATION_INSTALLATION_EQUIPMENT_ICON_PATH,
        link: RouteService.getEquipmentInstallation()
    },
    {
        translateKeyName: "operations.uninstall-equipment",
        iconPath: MarkerIconService.OPERATION_UNINSTALL_EQUIPMENT_ICON_PATH,
        link: RouteService.getEquipmentUninstallation()
    },
    {
        translateKeyName : "operations.element-installation",
        iconPath: MarkerIconService.OPERATION_INSTALLATION_ELEMENT_ICON_PATH,
        link: RouteService.getElementInstallation()
    },
    {
        translateKeyName: "operations.uninstall-element",
        iconPath: MarkerIconService.OPERATION_UNINSTALL_ELEMENT_ICON_PATH,
        link: RouteService.getElementUninstallation()
    },
    {
        translateKeyName: "operations.replace-element",
        iconPath: MarkerIconService.OPERATION_REPLACE_ELEMENT_ICON_PATH,
        link: RouteService.getElementReplacement()
    },
    {
        translateKeyName: "operations.geolocate",
        iconPath: MarkerIconService.OPERATION_GEOLOCATE_ICON_PATH,
        link: RouteService.getGeolocation()
    }
];

interface IOperationsWithIconUrl {
    translateKeyName: string;
    iconPath: string;
    link: string;
}
